import { Blueprint } from '../../blueprint.class';
import { BlueprintInstanceType } from '../../../shared.enums';
import { PanelItem } from '../../../panel-items/panel-item.class';
import { ToolResult } from '../../types';
import { cleanKitchenTool } from './clean-kitchen.tool';

export interface ReplaceApplianceArgs {
	applianceId: string;
	newSku: string;
	autoSize?: boolean;
}

export const replaceApplianceTool = (blueprint: Blueprint, { applianceId, newSku, autoSize }: ReplaceApplianceArgs): ToolResult<{ newItemId: string }> => {
	if (!applianceId) return { success: false, error: 'Missing applianceId. Use list_appliances to get valid item IDs.' };
	if (!newSku) return { success: false, error: 'Missing newSku. Use get_appliances with a valid category to get available SKUs.' };

	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) return { success: false, error: 'No active kitchen found.' };

	// Verify the new SKU exists
	const component = blueprint.context.components.findSku(newSku);
	if (!component) return { success: false, error: `SKU '${newSku}' not found. Use get_appliances with a valid category to get available SKUs.` };

	// Find the existing appliance
	const [type, item] = kitchen.getReferenceItem(applianceId);
	if (!item) return { success: false, error: `Appliance '${applianceId}' not found. Use list_appliances to get valid item IDs.` };

	if (type !== BlueprintInstanceType.PanelItem) {
		return { success: false, error: `Item '${applianceId}' is not an appliance (type: ${type}).` };
	}

	const panelItem = item as PanelItem;
	const islandId = panelItem.refMap.island?.id;

	// Swap the item in-place - preserves group membership and position
	panelItem.swapItem(newSku);

	// Clean the island to redistribute appliances
	if (islandId) {
		cleanKitchenTool(blueprint, { islandId, autoResize: autoSize });
	}

	return {
		success: true,
		message: `Replaced appliance '${applianceId}' with '${newSku}'.`,
		data: { newItemId: panelItem.id }
	};
};
